import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AtomicBlockUtils, EditorState, Modifier } from 'draft-js';
import classNames from 'classnames';
import Fa from 'react-fontawesome';

import Spinner from '../../../../components/spinner';

class Option extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const { disabled, onClick, value } = this.props;
    if (!disabled) {
      onClick(value);
    }
  }

  render() {
    const {
      children, className, activeClassName,
      active, disabled, title,
    } = this.props;
    return (
      <div
        className={classNames(
          'rdw-option-wrapper',
          className,
          {
            [`rdw-option-active ${activeClassName}`]: active,
            'rdw-option-disabled': disabled,
          },
        )}
        onClick={this.onClick}
        aria-selected={active}
        title={title}
      >
        {children}
      </div>
    );
  }
}

Option.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.any,
  value: PropTypes.string,
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  title: PropTypes.string,
};

function isWebmFile(mimeType) {
  return mimeType === 'video/webm';
}

class LayoutComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgSrc: '',
      mimeType: null,
      dragEnter: false,
      uploadHighlighted: props.config.uploadEnabled && !!props.config.uploadCallback,
      showImageLoading: false,
      height: props.config.defaultSize.height,
      width: props.config.defaultSize.width,
      alt: '',
    };
    this.onDragEnter = this.onDragEnter.bind(this);
    this.onImageDrop = this.onImageDrop.bind(this);
    this.showImageUploadOption = this.showImageUploadOption.bind(this);
    this.addImageFromState = this.addImageFromState.bind(this);
    this.showImageURLOption = this.showImageURLOption.bind(this);
    this.toggleShowImageLoading = this.toggleShowImageLoading.bind(this);
    this.updateValue = this.updateValue.bind(this);
    this.selectImage = this.selectImage.bind(this);
    this.uploadImage = this.uploadImage.bind(this);
    this.fileUploadClick = this.fileUploadClick.bind(this);
    this.stopPropagation = this.stopPropagation.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.expanded && !nextProps.expanded) {
      this.setState({
        imgSrc: '',
        mimeType: null,
        dragEnter: false,
        uploadHighlighted: this.props.config.uploadEnabled && !!this.props.config.uploadCallback,
        showImageLoading: false,
        height: this.props.config.defaultSize.height,
        width: this.props.config.defaultSize.width,
        alt: '',
      });
    } else if (nextProps.config.uploadCallback !== this.props.config.uploadCallback ||
      nextProps.config.uploadEnabled !== this.props.config.uploadEnabled) {
      this.setState({
        uploadHighlighted: nextProps.config.uploadEnabled && !!nextProps.config.uploadCallback,
      });
    }
  }

  onDragEnter(event) {
    this.stopPropagation(event);
    this.setState({
      dragEnter: true,
    });
  }

  onImageDrop(event) {
    event.preventDefault();
    event.stopPropagation();
    this.setState({
      dragEnter: false,
    });

    // Check if property name is files or items
    // IE uses 'files' instead of 'items'
    let data;
    let dataIsItems;
    if (event.dataTransfer.items) {
      data = event.dataTransfer.items;
      dataIsItems = true;
    } else {
      data = event.dataTransfer.files;
      dataIsItems = false;
    }
    for (let i = 0; i < data.length; i += 1) {
      if ((!dataIsItems || data[i].kind === 'file') && data[i].type.match('^image/')) {
        const file = dataIsItems ? data[i].getAsFile() : data[i];
        this.uploadImage(file);
      }
    }
  }

  showImageUploadOption() {
    this.setState({
      uploadHighlighted: true,
    });
  }

  addImageFromState() {
    const { imgSrc, alt, mimeType } = this.state;
    let { height, width } = this.state;
    const { onChange } = this.props;

    if (!Number.isNaN(height) && height !== 'auto') {
      height += 'px';
    }

    if (!Number.isNaN(width) && width !== 'auto') {
      width += 'px';
    }

    onChange(imgSrc, height, width, alt, mimeType);
  }

  showImageURLOption() {
    this.setState({
      uploadHighlighted: false,
    });
  }

  toggleShowImageLoading() {
    const showImageLoading = !this.state.showImageLoading;
    this.setState({
      showImageLoading,
    });
  }

  updateValue(event) {
    this.setState({
      [`${event.target.name}`]: event.target.value,
    });
  }

  selectImage(event) {
    if (event.target.files && event.target.files.length > 0) {
      this.uploadImage(event.target.files[0]);
    }
  }

  uploadImage(file) {
    this.toggleShowImageLoading();
    const { uploadCallback } = this.props.config;
    uploadCallback(file)
      .then(({ data }) => {
        this.setState({
          showImageLoading: false,
          dragEnter: false,
          imgSrc: data.link || data.url,
          mimeType: data.type,
        });
        this.fileUpload = false;
      }).catch(() => {
        this.setState({
          showImageLoading: false,
          dragEnter: false,
        });
      });
  }

  fileUploadClick(event) {
    this.fileUpload = true;
    event.stopPropagation();
  }

  stopPropagation(event) {
    if (!this.fileUpload) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      this.fileUpload = false;
    }
  }

  renderPreview() {
    const { imgSrc, mimeType } = this.state;

    if (isWebmFile(mimeType)) {
      return (
        <video width="100%" height="auto" controls>
          <source src={imgSrc} type="video/webm" />
          Your browser does not support the video tag.
        </video>
      );
    }

    return (
      <img
        src={imgSrc}
        alt={imgSrc}
        className="rdw-image-modal-upload-option-image-preview"
      />
    );
  }

  renderAddImageModal() {
    const {
      imgSrc,
      uploadHighlighted,
      showImageLoading,
      dragEnter,
      height,
      width,
      alt,
      mimeType,
    } = this.state;
    const {
      config: {
        popupClassName,
        uploadCallback,
        uploadEnabled,
        urlEnabled,
        previewImage,
        inputAccept,
      },
      doCollapse,
      translations,
    } = this.props;
    const altConf = this.props.config.alt;
    const isVideo = isWebmFile(mimeType);

    return (
      <div
        className={classNames('rdw-image-modal', popupClassName)}
        onClick={this.stopPropagation}
      >
        {uploadEnabled && uploadCallback && urlEnabled &&
          <div className="rdw-image-modal-header">
            {uploadEnabled && uploadCallback &&
              <span
                onClick={this.showImageUploadOption}
                className="rdw-image-modal-header-option"
              >
                {translations['components.controls.image.fileUpload']}
                <span
                  className={classNames(
                    'rdw-image-modal-header-label',
                    { 'rdw-image-modal-header-label-highlighted': uploadHighlighted },
                  )}
                />
              </span>}
            {urlEnabled &&
              <span
                onClick={this.showImageURLOption}
                className="rdw-image-modal-header-option"
              >
                {translations['components.controls.image.byURL']}
                <span
                  className={classNames(
                    'rdw-image-modal-header-label',
                    { 'rdw-image-modal-header-label-highlighted': !uploadHighlighted },
                  )}
                />
              </span>}
          </div>
        }
        {
          uploadHighlighted ?
            <div onClick={this.fileUploadClick}>
              <div
                onDragEnter={this.onDragEnter}
                onDragOver={this.stopPropagation}
                onDrop={this.onImageDrop}
                className={classNames(
                  'rdw-image-modal-upload-option',
                  { 'rdw-image-modal-upload-option-highlighted': dragEnter },
)}
              >
                <label
                  htmlFor="file"
                  className="rdw-image-modal-upload-option-label"
                >
                  { previewImage && imgSrc
                    ? this.renderPreview()
                    : imgSrc || translations['components.controls.image.dropFileText']}
                </label>
              </div>
              <input
                type="file"
                id="file"
                accept={inputAccept}
                onChange={this.selectImage}
                className="rdw-image-modal-upload-option-input"
              />
            </div> :
            <div className="rdw-image-modal-url-section">
              <input
                className="rdw-image-modal-url-input"
                placeholder={translations['components.controls.image.enterlink']}
                name="imgSrc"
                onChange={this.updateValue}
                onBlur={this.updateValue}
                value={imgSrc}
              />
              <span className="rdw-image-mandatory-sign">*</span>
            </div>
        }
        {!isVideo && altConf.present &&
          <div className="rdw-image-modal-size">
            <span className="rdw-image-modal-alt-lbl">Alt Text</span>
            <input
              onChange={this.updateValue}
              onBlur={this.updateValue}
              value={alt}
              name="alt"
              className="rdw-image-modal-alt-input"
              placeholder="alt"
            />
            <span className="rdw-image-mandatory-sign">{altConf.mandatory && '*'}</span>
          </div>
        }
        {!isVideo &&
          <div className="rdw-image-modal-size">
            &#8597;&nbsp;
            <input
              onChange={this.updateValue}
              onBlur={this.updateValue}
              value={height}
              name="height"
              className="rdw-image-modal-size-input"
              placeholder="Height"
            />
            <span className="rdw-image-mandatory-sign">*</span>
            &nbsp;&#8596;&nbsp;
            <input
              onChange={this.updateValue}
              onBlur={this.updateValue}
              value={width}
              name="width"
              className="rdw-image-modal-size-input"
              placeholder="Width"
            />
            <span className="rdw-image-mandatory-sign">*</span>
          </div>
        }
        <span className="rdw-image-modal-btn-section">
          <button
            className="rdw-image-modal-btn"
            onClick={this.addImageFromState}
            disabled={!imgSrc || !height || !width || (altConf.mandatory && !alt)}
          >
            {translations['generic.add']}
          </button>
          <button
            className="rdw-image-modal-btn"
            onClick={doCollapse}
          >
            {translations['generic.cancel']}
          </button>
        </span>
        {showImageLoading ?
          <div className="rdw-image-modal-spinner">
            <Spinner />
          </div> :
          undefined}
      </div>
    );
  }

  render() {
    const {
      config: { icon, className, title },
      expanded,
      onExpandEvent,
      translations,
    } = this.props;
    return (
      <div
        className="rdw-image-wrapper"
        aria-haspopup="true"
        aria-expanded={expanded}
        aria-label="rdw-image-control"
      >
        <Option
          className={classNames(className)}
          value="unordered-list-item"
          onClick={onExpandEvent}
          title={title || translations['components.controls.image.image']}
        >
          <Fa name="image" style={{ color: '#222' }} />
        </Option>
        {expanded ? this.renderAddImageModal() : undefined}
      </div>
    );
  }
}

LayoutComponent.propTypes = {
  expanded: PropTypes.bool,
  onExpandEvent: PropTypes.func,
  doCollapse: PropTypes.func,
  onChange: PropTypes.func,
  config: PropTypes.shape({}).isRequired,
  translations: PropTypes.shape({}),
};


class ImageControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
    this.expandCollapse = this.expandCollapse.bind(this);
    this.doExpand = this.doExpand.bind(this);
    this.doCollapse = this.doCollapse.bind(this);
    this.addImage = this.addImage.bind(this);
    this.onExpandEvent = this.onExpandEvent.bind(this);
  }

  componentWillMount() {
    const { modalHandler } = this.props;
    modalHandler.registerCallBack(this.expandCollapse);
  }

  componentWillUnmount() {
    const { modalHandler } = this.props;
    modalHandler.deregisterCallBack(this.expandCollapse);
  }

  onExpandEvent() {
    this.signalExpanded = !this.state.expanded;
  }

  doExpand() {
    this.setState({
      expanded: true,
    });
  }

  doCollapse() {
    this.setState({
      expanded: false,
    });
  }

  expandCollapse() {
    this.setState({
      expanded: this.signalExpanded,
    });
    this.signalExpanded = false;
  }


  addImage(src, height, width, alt, mimeType) {
    const { editorState, onChange, config } = this.props;
    const entityData = { src, height, width };
    if (config.alt.present) {
      entityData.alt = alt;
    }
    if (isWebmFile(mimeType)) {
      // const text = `\n[video width="${width}" height="${height}"]${src}[/video]\n`;
      const text = `\n![video](${src})\n`;
      const contentState = Modifier.replaceText(
        editorState.getCurrentContent(),
        editorState.getSelection(),
        text,
        null,
      );
      onChange(EditorState.push(editorState, contentState, 'insert-characters'));
    } else {
      const entityKey = editorState
        .getCurrentContent()
        .createEntity('IMAGE', 'MUTABLE', entityData)
        .getLastCreatedEntityKey();
      const newEditorState = AtomicBlockUtils.insertAtomicBlock(
        editorState,
        entityKey,
        ' ',
      );
      onChange(newEditorState);
    }
    this.doCollapse();
  }

  render() {
    const { config, translations } = this.props;
    const { expanded } = this.state;
    const ImageComponent = config.component || LayoutComponent;
    return (
      <ImageComponent
        config={config}
        translations={translations}
        onChange={this.addImage}
        expanded={expanded}
        onExpandEvent={this.onExpandEvent}
        doExpand={this.doExpand}
        doCollapse={this.doCollapse}
      />
    );
  }
}

ImageControl.propTypes = {
  editorState: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
  modalHandler: PropTypes.object,
  config: PropTypes.shape({}).isRequired,
  translations: PropTypes.shape({}),
};

export default ImageControl;
